import React from 'react';
import DashContainer from 'modules/dashboard/_common/DashContainer';
import CustomersPage from 'modules/dashboard/producer/customers/CustomersPage';

export default function DashProducerCustomers() {
    return (
        <DashContainer title='Clientes'>
            <CustomersPage />
        </DashContainer>
    );
}
